import { Subdivision } from '~/shared/api'
import {
  incidentResponsibleEnumOptions,
  roadAccidentsEnumOptions,
} from '~/shared/config/constants'
import { Filter } from '~/shared/ui/AsyncGrid/types'

export const filters: Filter[] = [
  {
    label: 'filter.number',
    field: 'number',
    type: 'text',
  },
  {
    label: 'filter.date',
    startField: 'createdAtGte',
    endField: 'createdAtLte',
    type: 'dateRange',
  },
  {
    label: 'filter.status',
    field: 'status',
    type: 'select',
    options: roadAccidentsEnumOptions,
  },
  {
    label: 'filter.plate number',
    field: 'carPlateNumber',
    type: 'text',
  },
  {
    label: 'filter.subdivision',
    field: 'subdivisionId',
    type: 'autocomplete',
    fetchOptions: Subdivision.fetchOptions,
  },
  {
    label: 'filter.repair order',
    field: 'hasRepairOrder',
    type: 'select',
    options: [
      { id: 'true', label: 'filter.yes' },
      { id: 'false', label: 'filter.no' },
    ],
  },
  {
    label: 'filter.guilt',
    field: 'culpability',
    type: 'select',
    options: incidentResponsibleEnumOptions,
  },
]
